import React, { useState, useEffect, useRef } from "react";
import { validateEmail } from "_helperFunctions/validateEmail";
import {
    getFeatureSetOption,
    getFeaturesList,
    isUserAdmin,
    controlType,
    isUserSupport
} from "../../../constant";
import { AccordionStyled } from "assets/css/globle";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Container } from "pages/Fleet/Settings/SettingsStyled";
import { useHookstate } from "@hookstate/core";
import {
    MAP_GLOBAL_STATES,
    FLEET_GLOBAL_STATES,
    MAX_HOLES_GLOBAL_STATE,
    SITEID_GLOBAL_STATE,
    CHECKBOX_LOADER,
    MAX_VOLUME_ALLOWED,
    ADS_GLOBAL_STATE,
    SIDENAV_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

// modal
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { PopUpContainer } from "assets/css/globle";

import { useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import { GeneralAccordion } from "./Accordions/GeneralAccordion";
import { ScorecardAccordion } from "./Accordions/ScorecardAccordion";
import { RoundManagementAccordion } from "./Accordions/RoundManagementAccordion";
import { AlertsAccordion } from "./Accordions/AlertsAccordion";
import { ScheduledFleetLockdownAccordion } from "./Accordions/ScheduledFleetLockdownAccordion";
import { OffPeakChargingAccordion } from "./Accordions/OffPeakChargingAccordion";
import { LiabilityWaiverAccordion } from "./Accordions/LiabilityWaiverAccordion";
import { AdminSupportSettingsAccordion } from "./Accordions/AdminSupportSettingsAccordion";
import { SSIDListAccordion } from "./Accordions/SSIDListAccordion";

export const Settings = () => {
    const navigate = useNavigate();
    const { alertMsg, redirectState, nextTabIndex, nextStageName } = useHookstate(ADS_GLOBAL_STATE);
    const { siteId, hideSubNav } = useHookstate(SITEID_GLOBAL_STATE);
    const { subNavDataState, sideDrawerActiveTabState } = useHookstate(SIDENAV_GLOBAL_STATE);

    const { t } = useTranslation();

    const {
        LoadingState,
        scoreCardTabLoader,
        roundManagementLoader
    } = useHookstate(CHECKBOX_LOADER);

    const { maxHolesAllowed } = useHookstate(MAX_HOLES_GLOBAL_STATE);
    const dispatch = useDispatch();

    const {
        PrintScorecardGlobal,
        ShareScorecardGlobal,
        AutoplayFlyoversGlobal,
        ShowOverMaxHolesOnCartGlobal,
        opcEnableLockdownGlobal,
        DisableDistancesOnMaxHolesGlobal,
        Heatmap,
        callSiteSelection
    } = useHookstate(MAP_GLOBAL_STATES);

    const {
        siteSettingsData,
        getUserRole,
        getRoundTimeOutData,
        putWelcomeScreenTextMessageData,
        getSiteOffPeakCharginData,
        getCarsData
    } = useSelector((state) => state?.commonReducers) || [];

    const { fleetSettingColorGlobalState } = useHookstate(FLEET_GLOBAL_STATES);

    const { maxVolumeAllowed, maxVolumeOptionTriggered } = useHookstate(MAX_VOLUME_ALLOWED);

    // modal state starts
    const [modal, setModal] = React.useState(false);
    const [messageBoxValue, setMessageBoxValue] = useState("");
    const [messageBoxCount, setMessageBoxCount] = useState(0);
    const [roundTimeout, setRoundTimeout] = useState();
    const [stagingTimeout, setStagingTimeout] = useState();
    const [resetRoundTimeout, setResetRoundTimeout] = useState();
    const [resetStagingTimeout, setResetStagingTimeout] = useState();
    const [roundManagementButton, setRoundManagementButton] = useState(false);
    const [roundManagement2Button, setRoundManagement2Button] = useState(false);
    const [schedLockdownSaveButton, setSchedLockdownSaveButton] = useState(false);
    const [dataSetForRoundManagement, setDataSetForRoundManagement] = useState({
        WelcomeScreenText: "",
        RoundTimeout: "60",
        StagingTimeout: "15",
        MaxNumberOfHoles: null,
        ScorecardEmail: "",
        ShowOverMaxHolesOnCart: false,
        DisableDistancesOnMaxHoles: false,
        BehindPaceWarning: false
    });
    const [offPeakCharging, setOffPeakCharging] = useState({
        opcEnableLockdown: false,
        opcStartTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.StartMinutes, 0),
        opcEndTime: new Date(2000, 0, 1, 0, getSiteOffPeakCharginData?.EndMinutes, 0),
        allowOpportunityCharging: false,
    });
    const [tempEmail, setTempEmail] = useState("");
    const [waiverPublishedDate, setWaiverPublishedDate] = useState("");
    const [isValid, setIsValid] = useState("");

    const logoInputRef = useRef(null);
    const backgroundInputRef = useRef(null);

    const [memberTracking, setMemberTracking] = useState(null);
    const [memberAntiTamper, setMemberAntiTamper] = useState(null);

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "calc(100% - 40px)",
        bgcolor: "background.paper",
        borderRadius: "5px",
        overflow: "hidden",
    };

    useEffect(() => {
        setWaiverPublishedDate("");

        if (logoInputRef.current) {
            logoInputRef.current.value = '';
        }

        if (backgroundInputRef.current) {
            backgroundInputRef.current.value = '';
        }

        if (siteId.get() !== null) {
            dispatch(COMMON_SERVICES.getFaultsServices(siteId.get()));
            dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
            dispatch(COMMON_SERVICES.getScheduledFleetLockdownServices(0, siteId.get()));
            dispatch(COMMON_SERVICES.getSiteOffPeakCharginServices(0, siteId.get()));
            dispatch(COMMON_SERVICES.getRoundTimeOutServices(siteId.get()));
            dispatch(COMMON_SERVICES.getMessagesFromCarsServices("", siteId.get()));
            dispatch(COMMON_SERVICES.getWaiverTemplateService(parseInt(siteId.get())));
        }
    }, [siteId.get()]);

    useEffect(() => {
        if (getRoundTimeOutData) {
            setRoundTimeout(getRoundTimeOutData?.site?.RoundTimeoutSeconds / 60);
            setStagingTimeout(getRoundTimeOutData?.site?.StagingTimeoutSeconds / 60);
            setResetRoundTimeout(getRoundTimeOutData?.site?.RoundTimeoutSeconds / 60);
            setResetStagingTimeout(
                getRoundTimeOutData?.site?.StagingTimeoutSeconds / 60
            );
        }
    }, [getRoundTimeOutData]);

    useEffect(() => {
        if (Object.keys(siteSettingsData).length > 0) {
            setMessageBoxValue(siteSettingsData?.WelcomeScreenText ? siteSettingsData?.WelcomeScreenText : "");
            setMessageBoxCount(siteSettingsData?.WelcomeScreenText?.length ? siteSettingsData?.WelcomeScreenText?.length : 0);
            setTempEmail(siteSettingsData?.EmailAddress ? siteSettingsData?.EmailAddress : "");
            PrintScorecardGlobal.set(siteSettingsData.PrintScorecard);
            ShareScorecardGlobal.set(siteSettingsData.ShareScorecardEnabled)
            AutoplayFlyoversGlobal.set(siteSettingsData.AutoFlyovers);
            Heatmap.set(siteSettingsData?.GreenViewsEnabled);

            // Round Management
            ShowOverMaxHolesOnCartGlobal.set(siteSettingsData.MaxHolesExceededAlert);
            DisableDistancesOnMaxHolesGlobal.set(
                siteSettingsData.MaxHolesExceededDistancesDisabled
            );

            setDataSetForRoundManagement({
                ...dataSetForRoundManagement,
                ShowOverMaxHolesOnCart: siteSettingsData.MaxHolesExceededAlert,
                DisableDistancesOnMaxHoles:
                    siteSettingsData.MaxHolesExceededDistancesDisabled,
                MaxNumberOfHoles: siteSettingsData.MaxHolesAllowedFleet,
                BehindPaceWarning: siteSettingsData.PaceWarningPopupEnabled,
            });
            maxHolesAllowed.set(siteSettingsData.MaxHolesAllowedFleet);

            opcEnableLockdownGlobal.set(siteSettingsData.PaceEnabled);
            setOffPeakCharging({
                ...offPeakCharging,
                opcEnableLockdown: siteSettingsData.PaceEnabled,
            });
            maxVolumeAllowed.set(siteSettingsData.MaxAmpSetting);
            maxVolumeOptionTriggered.set(false);
            setMemberTracking(siteSettingsData.MemberCarTrackingLevel);
            setMemberAntiTamper(siteSettingsData.MemberAntiTamperMode || 0)
        }
    }, [siteSettingsData, LoadingState.get() === true, siteId.get()]);

    useEffect(() => {
        let getWelcomeTxt = putWelcomeScreenTextMessageData && putWelcomeScreenTextMessageData?.WelcomeScreenText;
        setMessageBoxValue(getWelcomeTxt);
    }, [putWelcomeScreenTextMessageData]);

    const doesFleetHasFusionCars = () => {
        return getCarsData?.some(x => x.Car.CarControlType == controlType.Fusion);
    }

    const handleTextRoundManagementOnSave = (name) => {
        setRoundManagementButton(false);
        setRoundManagement2Button(false);
        if (name === "screen") {
            dispatch(
                COMMON_SERVICES.putWelcomeScreenTextMessageServices(
                    messageBoxValue,
                    siteId.get()
                )
            );
            roundManagementLoader.set(true);

            setTimeout(() => {
                roundManagementLoader.set(false);
            }, 2000);
            setMessageBoxValue("");
        }

        if (name === "scorecardEmail") {
            let isValidEmail = tempEmail && tempEmail?.trim() !== "" ? validateEmail(tempEmail?.trim()) : true;
            if (isValidEmail) {
                setIsValid("");
                dispatch(
                    COMMON_SERVICES.putScoreCardEmailServices(tempEmail.trim(), siteId.get())
                );
                scoreCardTabLoader.set(true);
                setTimeout(() => {
                    scoreCardTabLoader.set(false);
                }, 2000);
            }
            else {
                setIsValid(<p style={{ color: "red" }}>{t("Email_is_not_valid")}</p>);
            }
        }

        if (name === "max_volume_allowed") {
            if (maxVolumeAllowed.get()) {
                dispatch(
                    COMMON_SERVICES.putMaxVolumeSettingService(maxVolumeAllowed.get(), siteId.get())
                );
            }
        }
    }

    //*************RESET BUTTONS*****************//
    const handleTextRoundManagementOnReset = (name) => {
        // reset button for Welcome screen text
        if (name === "screen") {
            setRoundManagementButton(false);
            setDataSetForRoundManagement({
                ...dataSetForRoundManagement,
                WelcomeScreenText:
                    siteSettingsData && siteSettingsData?.WelcomeScreenText,
            });
            setMessageBoxValue(
                siteSettingsData && siteSettingsData?.WelcomeScreenText
            );
            setMessageBoxCount(
                siteSettingsData && siteSettingsData?.WelcomeScreenText.length
            );
        }

        // reset button for scorecardEmail
        else if (name === "scorecardEmail") {
            setRoundManagement2Button(false);
            setDataSetForRoundManagement({
                ...dataSetForRoundManagement,
                ScorecardEmail: siteSettingsData && siteSettingsData?.EmailAddress,
            });
            let getEmailAddress = siteSettingsData && siteSettingsData?.EmailAddress;
            setTempEmail(getEmailAddress);
            // setTempEmail(siteSettingsData && siteSettingsData?.EmailAddress);
        } else if (name === "max_volume_allowed") {
            maxVolumeAllowed.set(siteSettingsData.MaxAmpSetting);
            maxVolumeOptionTriggered.set(false);
        } else {
        }
    }

    const handleCheckBox = (e) => {
        const payload = {
            siteId: siteId.get(),
            code: "WA",
            value: e,
            enumValue: 0,
        };

        dispatch(
            COMMON_SERVICES.putFleetSettingsServices(payload, siteId.get())
        ).then(() => {
            fleetSettingColorGlobalState.set(e);
            setModal(false);
        });
    }

    const handleDiscardPopup = () => {
        redirectState.set(false);
        alertMsg.set(false);

        hideSubNav.set(true);
        if (nextStageName.get() === "siteSelection") {
            callSiteSelection.set(true);
            setSchedLockdownSaveButton(false);
            return;
        }
        navigate(`/${nextStageName.get().toLowerCase()}`);
        let activeTab = nextTabIndex.get();
        let activeName = nextStageName.get();
        sideDrawerActiveTabState.set(activeTab);
        subNavDataState.set(activeName);

        localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

        localStorage.setItem("subNavState", "true");
        localStorage.setItem("subNavDataState", nextStageName.get());
    }

    return (
        <>
            <Container>
                <AccordionStyled>
                    <GeneralAccordion
                        handleTextRoundManagementOnSave={handleTextRoundManagementOnSave}
                        handleTextRoundManagementOnReset={handleTextRoundManagementOnReset}
                    />

                    <ScorecardAccordion
                        handleTextRoundManagementOnSave={handleTextRoundManagementOnSave}
                        handleTextRoundManagementOnReset={handleTextRoundManagementOnReset}
                        tempEmail={tempEmail}
                        setTempEmail={setTempEmail}
                        roundManagement2Button={roundManagement2Button}
                        setRoundManagement2Button={setRoundManagement2Button}
                        isValid={isValid}
                    />

                    <RoundManagementAccordion
                        handleTextRoundManagementOnSave={handleTextRoundManagementOnSave}
                        handleTextRoundManagementOnReset={handleTextRoundManagementOnReset}
                        roundManagementButton={roundManagementButton}
                        setRoundManagementButton={setRoundManagementButton}
                        messageBoxValue={messageBoxValue}
                        setMessageBoxValue={setMessageBoxValue}
                        messageBoxCount={messageBoxCount}
                        setMessageBoxCount={setMessageBoxCount}
                        roundTimeout={roundTimeout}
                        setRoundTimeout={setRoundTimeout}
                        stagingTimeout={stagingTimeout}
                        resetRoundTimeout={resetRoundTimeout}
                        resetStagingTimeout={resetStagingTimeout}
                        setStagingTimeout={setStagingTimeout}
                    />

                    {!getFeatureSetOption(siteSettingsData && siteSettingsData !== null && siteSettingsData?.Features, getFeaturesList().car_control) &&
                        getUserRole && getUserRole.Role != 6 &&
                        <AlertsAccordion />
                    }

                    <ScheduledFleetLockdownAccordion
                        schedLockdownSaveButton={schedLockdownSaveButton}
                        setSchedLockdownSaveButton={setSchedLockdownSaveButton}
                    />

                    {doesFleetHasFusionCars() &&
                        <OffPeakChargingAccordion
                            offPeakCharging={offPeakCharging}
                            setOffPeakCharging={setOffPeakCharging}
                        />
                    }

                    <LiabilityWaiverAccordion
                        waiverPublishedDate={waiverPublishedDate}
                        setWaiverPublishedDate={setWaiverPublishedDate}
                        logoInputRef={logoInputRef}
                        backgroundInputRef={backgroundInputRef}
                    />

                    {(isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role)) &&
                        <AdminSupportSettingsAccordion
                            memberAntiTamper={memberAntiTamper}
                            setMemberAntiTamper={setMemberAntiTamper}
                            memberTracking={memberTracking}
                            setMemberTracking={setMemberTracking}
                        />
                    }

                    <SSIDListAccordion />
                </AccordionStyled>

                <Modal
                    open={modal}
                    onClose={() => setModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <PopUpContainer>
                            <h2>{t("Confirm")}</h2>
                            <p>{t("Engage_weather_alert?")}</p>
                            <div className="action-btn">
                                <button
                                    onClick={() => {
                                        handleCheckBox(!fleetSettingColorGlobalState.get());
                                    }}
                                    className="primary"
                                >
                                    {t("Yes")}
                                </button>
                                <button onClick={() => setModal(false)}>{t("No")}</button>
                            </div>
                        </PopUpContainer>
                    </Box>
                </Modal>
                <Modal
                    open={alertMsg.get()}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <PopUpContainer>
                            <h2>{t("Confirm")}</h2>
                            <p>{t("Discard_changes")}?</p>
                            <div className="action-btn">
                                <button className="primary" onClick={handleDiscardPopup}>
                                    {t("Yes")}
                                </button>
                                <button
                                    onClick={() => {
                                        alertMsg.set(false);
                                    }}
                                >
                                    {t("No")}
                                </button>
                            </div>
                        </PopUpContainer>
                    </Box>
                </Modal>
            </Container>
        </>
    );
};
